import { cn } from '@/lib/utils'
import type { PanelArtProps } from './panel-art-props'

/**
 * Scanner Parity panel art: two ranked lists side by side (database, real
 * time) with links between matching rows, one crossing where the order moved.
 */
export function ScannerParityArt({ className }: PanelArtProps) {
  const rows = [26, 42, 58, 74]
  return (
    <svg
      viewBox="0 0 160 100"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      focusable="false"
      className={cn('h-full w-full', className)}
    >
      {rows.map((y, i) => (
        <g key={y}>
          <rect
            x={18}
            y={y - 4}
            width={40}
            height={8}
            rx={3}
            fill="hsl(var(--foreground) / 0.22)"
          />
          <rect
            x={102}
            y={y - 4}
            width={40}
            height={8}
            rx={3}
            fill={i === 3 ? 'hsl(var(--warning) / 0.55)' : 'hsl(var(--foreground) / 0.22)'}
          />
        </g>
      ))}
      {[
        [26, 26],
        [42, 58],
        [58, 42],
      ].map(([a, b]) => (
        <line
          key={`${a}-${b}`}
          x1={62}
          y1={a}
          x2={98}
          y2={b}
          stroke={a === b ? 'hsl(var(--chart-candle-up))' : 'hsl(var(--primary))'}
          strokeWidth="1.5"
          vectorEffect="non-scaling-stroke"
        />
      ))}
      <line
        x1={62}
        y1={74}
        x2={98}
        y2={74}
        stroke="hsl(var(--warning))"
        strokeWidth="1.5"
        strokeDasharray="3 3"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  )
}
